/**
 * Utility to transform various invoice types into invoice-sources component.
 */

import React from "react";
import { getLedgerTransactionsFromInvoice } from "../../../utils/utils";
import { InvoiceSources } from './invoice-sources';
import './styles/index.scss';
export function invoiceAPInvoicesToInvoiceSources(
  invoices: InvoicesAPI.Invoice[] | AmplifyAPI.Invoice[],
) {

  if (!invoices || invoices.length === 0) {
    return <span>No code sources available.</span>;
  }

  const invoiceHasCodes = (
    invoice: InvoicesAPI.Invoice | AmplifyAPI.Invoice
  ) => {
    return invoice.transactions?.some(
      transaction =>
        transaction.diagnoses?.length > 0 ||
        transaction?.procedure != null ||
        transaction.modifiers?.length > 0
    );
  };

  // Type assertion to handle the union type properly
  const filteredInvoices = (invoices as (
    | InvoicesAPI.Invoice
    | AmplifyAPI.Invoice
  )[]).filter(invoice => invoiceHasCodes(invoice));
  return (
    <InvoiceSources
      invoices={filteredInvoices.map(invoice => {
        const ledgerTransactions = getLedgerTransactionsFromInvoice(invoice);

        return {
          id: invoice.guid,
          type: invoice.type,
          performingProviderName: invoice.performing_provider_name,
          ledgerTransactions, 
          transactions: invoice.transactions?.map(transaction => ({
            id: transaction.guid,
            diagnoses: transaction.diagnoses?.map(d => ({ code: d.diagnosis_code })),
            modifiers: transaction.modifiers?.map(m => ({ code: m.modifier_code })),
            procedures: [
              {
                displayTechnicalCodeUnits: !transaction.procedure,
                procedure: transaction.procedure
                  ? {
                      code: transaction.procedure.procedure_code,
                      units: transaction.procedure.units
                    }
                  : null,
                technicalCode: transaction.technical_code
                  ? {
                      code: transaction.technical_code.code,
                      units: transaction.technical_code.units
                    }
                  : null
              }
            ]
          }))
        };
      })}
    />
  );
}
